import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';

const getPoliPaymentStatus = async ({
    requestId, sessionId, query: {paymentSessionId}
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const logProps = {requestId, sessionId, paymentSessionId};

    logger.info('Retrieving Poli payment status', {
        eventId: eventIds['Retrieving Poli payment status'],
        ...logProps
    });

    try {
        const url = new URL(`/api/sessions/${paymentSessionId}`, config.poliIntegrator.url);

        const response = await fetch(url.toString());

        throwOnResponseError(response);
        const statusData = await response.json();
        logger.info('Retrieved Poli payment status', {
            eventId: eventIds['Retrieved Poli payment status'],
            ...logProps,
            payload: statusData
        });

        return statusData;
    } catch (e) {
        const error = new Error(`Error retrieving Poli payment status: ${e.message}`);
        error.status = getErrorStatusCode(e);
        logger.error(error.message, {
            eventId: eventIds['Error retrieving Poli payment status'],
            ...logProps
        });

        throw error;
    }
};

export default getPoliPaymentStatus;
